module.exports = {
    //baseUrl: 'https://customerapi.livefacetof.com', // 正式项目地址
    // wsurl: 'wss://customerapi.livefacetof.com/staff',
    baseUrl: 'https://bwin-imapi.jinkunzs.com',
    wsurl: 'wss://bwin-imapi.jinkunzs.com/staff',
}